import { render, staticRenderFns } from "./UsersAvatarList.vue?vue&type=template&id=b6bf7584&scoped=true"
import script from "./UsersAvatarList.vue?vue&type=script&lang=js"
export * from "./UsersAvatarList.vue?vue&type=script&lang=js"
import style0 from "./UsersAvatarList.vue?vue&type=style&index=0&id=b6bf7584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bf7584",
  null
  
)

export default component.exports